import { render, staticRenderFns } from "./DoctorTraditionalMedicine.vue?vue&type=template&id=50140a3a&"
import script from "./DoctorTraditionalMedicine.vue?vue&type=script&lang=js&"
export * from "./DoctorTraditionalMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports